var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
let OutsourceList = class OutsourceList extends Vue {
    id = this.$route.params.id;
    search = '';
    filter = [];
    extern = [];
    index = 0;
    intern = {};
    loading = false;
    page = {
        total: 0
    };
    options = {
        itemsPerPage: 20,
        page: 1,
        total: 0
    };
    text = '';
    snackbar = false;
    timeout = 5000;
    color = "";
    pdf = new Blob();
    headers = [
        { text: 'Externe Auftragnummer', align: 'start', value: 'order_nr' },
        { text: 'Offenemenge', align: 'start', value: 'amount' },
        { text: 'Anforderungsmenge', align: 'start', value: 'inamount' },
        { text: 'Liefermenge', align: 'start', value: 'outamount' },
        { text: 'interner Auftrag', align: 'start', value: 'orders' },
        // {text: 'Gesammtpreis', align: 'start',value: 'total_price'},
        { text: 'Lieferant:', align: 'start', value: 'supplier' },
        { text: 'Abgeschlossen', align: 'start', value: 'complete' },
        { text: 'Lieferdatum:', align: 'start', value: 'delivery_date' },
        { text: 'Waren erhalten:', align: 'start', value: 'get_goods' },
        { text: 'Notiz', value: 'note' },
        { text: 'Aktionen', value: 'actions' },
    ];
    getExternList() {
        this.loading = true;
        this.setFilter('type', this.$attrs.type);
        this.setFilter('search', this.search);
        axios.get('/api/extern', {
            params: {
                itemsPerPage: this.options.itemsPerPage,
                page: this.options.page,
                sortBy: this.options.sortBy.toString(),
                sortDesc: this.options.sortDesc,
                filter: this.filter,
            }
        }).then((response) => {
            this.extern = response.data.data;
            this.page = response.data.meta;
            this.loading = false;
        });
        return this.extern;
    }
    filterOnlyLowerText(value, search, item) {
        return value != null &&
            search != null &&
            typeof value === 'string' &&
            value.toString().toLocaleLowerCase().indexOf(search) !== -1;
    }
    printPDF(id) {
        let url = "http://" + window.location.hostname + "/extern/" + id + "/pdf";
        window.open(url);
    }
    setFilter(key, value) {
        this.clearFilterByKey(key);
        if (value != -1 || value != '-1') {
            this.filter.push({ key: key, value: value });
        }
    }
    clearFilterByKey(key) {
        for (let i = 0; i < this.filter.length; i++) {
            if (this.filter[i].key == key) {
                this.filter.splice(i, 1);
            }
        }
        return false;
    }
    watchOptions() {
        this.getExternList();
        this.$store.state.monitor = false;
    }
    watchSearch() {
        this.getExternList();
        this.$store.state.monitor = false;
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getExternList();
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
__decorate([
    Watch('options', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OutsourceList.prototype, "watchOptions", null);
__decorate([
    Watch('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], OutsourceList.prototype, "watchSearch", null);
OutsourceList = __decorate([
    Component({
        name: "OutsourceList",
    })
], OutsourceList);
export default OutsourceList;
